import React from 'react';

const ResponsiveContainer = ({ children, className = '', size = 'xl' }) => {
  const maxWidthClasses = {
    md: 'max-w-3xl',
    lg: 'max-w-5xl',
    xl: 'max-w-7xl',
    full: 'max-w-full',
  };

  return (
    <div className={`w-full mx-auto px-3 py-3 sm:px-4 sm:py-4 md:px-6 md:py-6 ${maxWidthClasses[size] || maxWidthClasses.xl} ${className}`}>
      {children}
    </div>
  );
};

export default ResponsiveContainer;
